<template>
  <v-list-item-action>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn small color="success" icon
          v-on="on" @click="accept">
          <v-icon>mdi-phone</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('sipua.menu.accept') }}</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn small color="red" icon
          v-on="on" @click="reject">
          <v-icon>mdi-phone-cancel</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('sipua.menu.reject') }}</span>
    </v-tooltip>
  </v-list-item-action>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'active-calls-incall-actions',
  props: {
    call: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions({
      acceptCall: 'sipua/acceptCall',
      hangupCall: 'sipua/hangupCall',
      callsLogMissed: 'callsLogMissed'
    }),
    accept: function () {
      this.acceptCall(this.call.callid)
    },
    reject: function () {
      this.callsLogMissed({ num: this.call.number, name: this.call.name })
      this.hangupCall(this.call.callid)
    }
  }
}
</script>

<style scoped>
</style>
